import React from 'react';
import SAInputComponent from "./SAInputComponent";
import SAInputDistance from "./SAInputDistance";

class SAInputDistanceLabel extends React.Component {

  render() {
    const {label, value, onChange, error, ...attributes} = this.props;

    return (
      <SAInputComponent label={label}>
        <SAInputDistance onChange={onChange} value={value} error={error} {...attributes}/>
      </SAInputComponent>
    )
  }
}

export default SAInputDistanceLabel;
